<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'
import ToastContainer from '@/components/ui/ToastContainer.vue'

const authStore = useAuthStore()

onMounted(async () => {
  // Vérifier si un token existe au chargement (await pour éviter les race conditions)
  await authStore.checkAuth()
})
</script>

<template>
  <RouterView />
  <ToastContainer />
</template>
